import { Box } from "@mui/material";
import { SiteTheme } from "services/KnowfullyAdminClient";

const useStyles = (backgroundColor: string) => ({
  container: {
    height: 80,
    backgroundColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    px: 3,
    borderBottom: "1px solid #e0e0e0",
  },
  logo: {
    maxHeight: 60,
    maxWidth: 200,
    objectFit: "contain",
  },
});

type PreviewHeaderProps = {
  siteTheme: SiteTheme | undefined;
};

const PreviewHeader = ({ siteTheme }: PreviewHeaderProps) => {
  const backgroundColor = siteTheme?.backgroundColor?.base || "#f5f5f5";
  const styles = useStyles(backgroundColor);

  return (
    <Box sx={styles.container}>
      {siteTheme?.logoUrl && (
        <Box
          component="img"
          src={siteTheme.logoUrl}
          alt={siteTheme.logoAlternativeText || "Organization Logo"}
          sx={styles.logo}
        />
      )}
    </Box>
  );
};

export default PreviewHeader;
